/**
 * 骑士管理
 * */
import React from 'react';
import PropTypes from 'prop-types';
import Main from './main';

const CompBox = ({ history, match }) => {
    return <Main history={history} match={match} />;
};

CompBox.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object
};

export default CompBox;